<template>
  <div>
    <b-row>
      <b-col cols="12">
        <slide-top-dashboard />
      </b-col>
      <b-col v-if="isPn" cols="auto">
        <badges-dashboard />
      </b-col>
      <b-col v-if="isPn" cols="12">
        <dna-campaign-dashboard />
      </b-col>
      <b-col cols="12" class="mb-2">
        <h3>Lembretes</h3>
      </b-col>
      <b-col sm="12" lg="6">
        <ToDoList />
      </b-col>
      <b-col sm="12" lg="6">
        <weekly-schedule />
      </b-col>

      <!-- Campanhas Recentes -->
      <template v-if="recentCampaigns.length > 0">
        <b-col cols="12" class="mb-2">
          <div class="d-flex justify-content-between align-items-center">
            <h3>Campanhas Recentes</h3>
            <b-button
              variant="outline-primary"
              size="sm"
              @click="goToCampaigns"
            >
              Ver todas
            </b-button>
          </div>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col
              v-for="(campaign, index) in recentCampaigns"
              :key="campaign.id || index"
              sm="12"
              md="6"
              lg="4"
            >
              <campaign-card :campaign="campaign" />
            </b-col>
          </b-row>
        </b-col>
      </template>

      <b-col sm="12" lg="4">
        <birthdays-of-month />
      </b-col>
      <b-col sm="12" lg="4">
        <customers-reminder />
      </b-col>
      <b-col sm="12" lg="4">
        <leads-reminder />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import _ from "lodash";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification/composition";
import * as accountTypes from "@/modules/account/store/types";
import * as todoTypes from "@/modules/todo/store/types";
import * as kpiTypes from "@/modules/kpi/store/types";
import useAppConfig from "@core/app-config/useAppConfig";
import WeeklySchedule from "../components/WeeklySchedule.vue";
import BirthdaysOfMonth from "../components/BirthdaysOfMonth.vue";
import ToDoList from "@/modules/todo/components/ToDoList.vue";
import CustomersReminder from "../components/CustomersReminder.vue";
import LeadsReminder from "../components/LeadsReminder.vue";
import SlideTopDashboard from "../components/SlideTopDashboard.vue";
import BadgesDashboard from "../components/BadgesDashboard.vue";
import DnaCampaignDashboard from "../components/DnaCampaignDashboard.vue";
import CampaignCard from "../components/CampaignCard.vue";
import { isPnRole } from "@/constants/auth";

export default {
  components: {
    vSelect,
    WeeklySchedule,
    BirthdaysOfMonth,
    ToDoList,
    LeadsReminder,
    CustomersReminder,
    SlideTopDashboard,
    BadgesDashboard,
    DnaCampaignDashboard,
    CampaignCard,
  },
  setup() {
    const { skin } = useAppConfig();
    return { toast: useToast(), skin };
  },
  data() {
    return {
      loading: false,
      currentPage: 1,
      itemsPerPage: 1,
      searchQuery: "",
      sortField: null,
      order: undefined,
      recentCampaigns: [],
    };
  },
  computed: {
    ...mapGetters({
      user: accountTypes.USER,
    }),
    isPn: function () {
      return isPnRole(this.user?.user_contract_type_id);
    },
  },
  methods: {
    ...mapActions({
      openNewToDoSidebar: todoTypes.OPEN_NEW_TO_DO_SIDEBAR,
      getCampaignsKpi: kpiTypes.GET_CAMPAIGNS_KPI,
    }),

    fetchRecentCampaigns() {
      this.getCampaignsKpi()
        .then((resp) => {
          this.recentCampaigns = resp.data ? resp.data.slice(0, 3) : [];
        })
        .catch((error) => {
          console.error("Erro ao buscar campanhas:", error);
        });
    },

    goToCampaigns() {
      this.$router.push({ name: "campanhas" });
    },
  },

  mounted() {
    this.fetchRecentCampaigns();
    if (this.isPn) {
    }
  },
};
</script>

<style lang="scss">
.dash-customer .name-content {
  width: 170px;
  display: flex;
  justify-content: center;
}

.dash-customer .name-content .name {
  width: auto;
}

.dash-customer .name-content .name:hover {
  background-color: #f26237;
}

.dash-customer .whats {
  margin-left: 8px;
  margin-top: auto;
  margin-bottom: auto;
  cursor: pointer;
}

.dash-customer .whats:hover {
  background-color: #f26237;
}
</style>
